import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import OnboardingFlow from "./pages/OnboardingFlow";
import DashboardLayout from "./components/DashboardLayout";
import AnalysisStatus from "./pages/AnalysisStatus";
import GoogleOAuthCallback from "./pages/GoogleOAuthCallback";
import AdminDashboard from "./pages/AdminDashboard";
import AdminAccess from "./pages/AdminAccess";
import MyContent from "./pages/MyContent";
import UserSettings from "./pages/UserSettings";
import NotFound from "./pages/NotFound";
import ShopifyIntegration from "./pages/docs/ShopifyIntegration";
import WordPressIntegration from "./pages/docs/WordPressIntegration";
import WebflowIntegration from "./pages/docs/WebflowIntegration";
import FramerIntegration from "./pages/docs/FramerIntegration";
import WixIntegration from "./pages/docs/WixIntegration";
import About from "./pages/About";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Partners from "./pages/Partners";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";
import Documentation from "./pages/Documentation";
import Guides from "./pages/Guides";
import Updates from "./pages/Updates";
import Integrations from "./pages/Integrations";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ScrollToTop from "./components/ScrollToTop";
import { CookieBanner } from "./components/CookieBanner";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/onboarding" element={<OnboardingFlow />} />
          <Route path="/dashboard" element={<DashboardLayout />} />
          <Route path="/my-content" element={<DashboardLayout />} />
          <Route path="/settings" element={<DashboardLayout />} />
          <Route path="/analysis/:websiteId" element={<AnalysisStatus />} />
          <Route path="/oauth/google-search-console" element={<GoogleOAuthCallback />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin-access" element={<AdminAccess />} />
          <Route path="/docs/shopify-integration" element={<ShopifyIntegration />} />
          <Route path="/docs/wordpress-integration" element={<WordPressIntegration />} />
          <Route path="/docs/webflow-integration" element={<WebflowIntegration />} />
          <Route path="/docs/framer-integration" element={<FramerIntegration />} />
          <Route path="/docs/wix-integration" element={<WixIntegration />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/updates" element={<Updates />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
